// extracted by mini-css-extract-plugin
export default {"link":"VN-z","disabled":"WN-z"};